<template>
  <div class="drag_popup" style="background: #fff;">
    <div class="drag_mark">
      <div class="comImageValidate rightValidate">
        <div class="imgBg">
          <div class="imgBtn">
            <img />
          </div>
        </div>
        <div class="hkinnerWrap" style="position: relative">
          <span class="v_rightBtn" @touchmove="touchmove" @touchstart="touchstart" @touchend="touchend">
            <b class="notSel">| | |</b>
          </span>
          <span class="huakuai" style="font-size: 12px;color: #A9A9A9;padding-left: 50px;">向右滑动滑块填充拼图完成验证</span>
          <input type="hidden" name="validX" />
        </div>
      </div>
      <div class="take_btn">
        <span @click="offWrap()">
          <img style="width: 16px;height: 16px;" src="../images/login/ico_close.svg" alt />
        </span>
        <span class="refresh">
          <img alt src="../images/login/refrish.svg" />
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import QRCode from "qrcodejs2";
import { EduSSO } from "../../static/utils/sso";
// import "../assets/drag.js";

var tokenId = "";
var y = "";
var x = "";
export default {
  data() {
    return {
      isSuc: false,
      showImgErrCode: false,
      isOnline: true,  // 是否为线上
      startPageX: '', //初始时滑块的位置
    };
  },
  created() { },
  mounted() {
    this.getDragEvent();
    this.validateImageInit();
  },
  methods: {
    // 开始滑动
    touchstart(e) {
      this.startPageX = e.touches[0].pageX
    },
    // 滑动中
    touchmove(e) {
      console.log(e);
      let newL = e.touches[0].pageX - this.startPageX
      $(".v_rightBtn").css("left", newL + "px");
      $(".imgBtn").css("left", newL + "px");
    },
    // 滑动结束
    touchend() {
      let l = $(".imgBtn").css("left");
      if (l.indexOf("px") != -1) {
        l = l.substring(0, l.length - 2);
      }
      l = parseInt(Number(l))
      this.submitDate(l, y, tokenId);
    },
    //获取主机url
    getHostPath() {
      var curWwwPath = window.document.location.href;
      var pathName = window.document.location.pathname;
      var pos = curWwwPath.indexOf(pathName);
      var localhostPath = curWwwPath.substring(0, pos);
      this.isOnline = localhostPath.indexOf('hecs.fifedu.com/iplat/');
      return localhostPath;
    },
    //获取iplat路径
    getIplatPath() {
      var curWwwPath = window.document.location.href;
      var pos = curWwwPath.indexOf('/fifLogin');
      var iplatPath = curWwwPath.substring(0, pos);
      return iplatPath;
    },
    //获取iplat路径 线上下
    getIplatCasPath() {
      // 线上
      var login = `${window.globalParameter.VUE_APP_CYCORE}/cas-server`;
      return login;
    },
    getDragEvent() {
      const that = this;
      $(".comImageValidate").ready(function () {
        $(".refresh").click(function () {
          that.validateImageInit();
        });
        $(".hkinnerWrap")
          .mouseover(function () {
            $(".imgBg").css("display", "block");
            $(".refresh").css("display", "block");
          })
          .mouseleave(function () {
            $(".imgBg").css("display", "block");
            $(".refresh").css("display", "block");
          });

        $(".imgBg")
          .mouseover(function () {
            $(".imgBg").css("display", "block");
            $(".refresh").css("display", "block");
          })
          .mouseleave(function () {
            $(".imgBg").css("display", "block");
            $(".refresh").css("display", "block");
          });

        $(".v_rightBtn")
          .on({
            mousedown: function (e) {
              $(".huakuai").html("");
              $(".hkinnerWrap").removeClass("red green");
              var el = $(this);
              var os = el.offset();
              var dx = e.pageX - os.left;
              $(this).parents(".hkinnerWrap").off("mousemove");
              $(this).parents(".hkinnerWrap").on("mousemove", function (e) {
                var newLeft = e.pageX - dx;
                el.offset({
                  left: newLeft
                });
                var newL = parseInt($(".v_rightBtn").css("left"));
                if (newL <= 0) {
                  newL = 0;
                } else if (newL >= 236) {
                  newL = 236;
                }
                $(".v_rightBtn").css("left", newL + "px");
                $(".imgBtn").offset({
                  left: newLeft
                });
                $(".imgBtn").css("left", newL + "px");
              })
                .on("mouseup", function (e) {
                  //$(document)
                  $(this).off("mousemove");
                });
            }
          }).on("mouseup", function () {
            $(this).parents(".hkinnerWrap").off("mousemove");
            var l = $(this).css("left");
            if (l.indexOf("px") != -1) {
              l = l.substring(0, l.length - 2);
            }
            x = l;
            that.submitDate(l, y, tokenId);
          });
      });
    },
    /*图形验证*/
    submitDate(x, y, tokenId) {
      const that = this;
      $(".hkinnerWrap").addClass("green").removeClass("red");
      $(".hkinnerWrap input[name='validX']").val(x);
      $("#X").val(x);
      $("#Y").val(y);
      this.isSuc = true;
      that.$emit('offbtn', tokenId,x,y);
      this.showImgErrCode = false;
      // $.ajax({
      //   url: (this.isOnline ? "https://cycore.fifedu.com/fif_captcha" : "https://cycore.fifedu.com/fif_captcha") + "/getImgVerify?uuid=" + tokenId + "&X=" + x + "&Y=" + y,
      //   dataType: "json",
      //   type: "get",
      //   success: function (data) {
      //     if (data.data.check == "successed") {
      //       $(".hkinnerWrap").addClass("green").removeClass("red");
      //       $(".hkinnerWrap input[name='validX']").val(x);
      //       $("#X").val(x);
      //       $("#Y").val(y);
      //       that.isSuc = true;
      //       that.$emit('offbtn', tokenId);
      //       that.showImgErrCode = false;
      //     } else {
      //       $(".hkinnerWrap").addClass("red").removeClass("green");
      //       setTimeout(function () {
      //         $(".hkinnerWrap").removeClass("red green");
      //         $(".v_rightBtn").css("left", 0);
      //         $(".imgBtn").css("left", 0);
      //       }, 280);
      //       that.validateImageInit();
      //     }
      //   }
      // });
    },

    /*初始化图形验证码*/
    validateImageInit() {
      const that = this;
      $.ajax({
        url: `${window.globalParameter.VUE_APP_CYCORE}/fif_captcha` + "/getPcImgCode",
        dataType: "json",
        cache: false,
        type: "get",
        success: function (data) {
          $(".huakuai").html("向右滑动滑块填充拼图");
          $(".imgBg").css("background", '#fff url("data:image/jpg;base64,' + data.data.oriCopyImage + '")'
          );
          $(".imgBtn").css("top", "25px");
          $(".imgBtn").find("img").attr("src", "data:image/png;base64," + data.data.newImage);
          tokenId = data.data.uuid;
          y = data.data.Y;
          $(".hkinnerWrap").removeClass("red green");
          $(".v_rightBtn").css("left", 0);
          $(".imgBtn").css("left", 0);
        },
        error: function (err) {
          that.validateImageInit();
        }
      });
    },
    offWrap() {
      //this.isSuc = true;
      this.showImgErrCode = false;
      this.$emit('offbtn', this.showImgErrCode);
    }
  }
};
</script>

<style>
.drag_popup {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  position: relative;
  z-index: 100;
}

.drag_mark {
  width: 320px;
  height: 300px;
  position: absolute;
  top: -5px;
  left: -14px;
  background: #fff;
  display: flex;
  justify-content: center;
  box-shadow: 0px 32px 48px -10px rgba(5, 14, 26, 0.2);
  border: 1px solid rgba(229, 229, 229, 1);
}

.rightValidate {
  width: 280px;
  padding-top: 20px;
  position: relative;
  text-align: center;
  z-index: 99;
}

.v_rightBtn {
  position: absolute;
  left: 0;
  top: -6px;
  cursor: pointer;
  width: 60px;
  height: 35px;
  line-height: 30px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.15);
  border-radius: 20px;
  border: 1px solid rgba(229, 229, 229, 1);
}

.imgBtn {
  width: 44px;
  height: 171px;
  position: absolute;
  left: 0;
}

.imgBtn img {
  width: 100%;
  z-index: 99;
}

.imgBg {
  bottom: 35px;
  width: 280px;
  height: 171px;
  box-shadow: 0px 4px 8px #3c5476;
  z-index: 9;
}

.hkinnerWrap {
  border: 1px solid #eee;
  margin: 24px 0;
  width: 100%;
  height: 24px;
  background: rgba(245, 245, 245, 1);
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.15);
  border-radius: 12px;
}

.green {
  border-color: #34c6c2 !important;
}

.green .v_rightBtn {
  background: #34c6c2;
  color: #fff;
}

.red {
  border-color: red !important;
}

.red .v_rightBtn {
  background: red;
  color: #fff;
}

.take_btn span {
  padding-right: 24px;
  cursor: pointer;
}

.refresh img {
  width: 30px;
  height: 30px;
}

.notSel {
  color: #2fcbeb;
  font-weight: bolder;
  font-size: 14px;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  -webkit-touch-callout: none;
}

.take_btn {
  width: 100%;
  height: 40px;
  position: absolute;
  z-index: 666;
  left: 0;
  bottom: 0;
  height: 45px;
  border-top: 1px solid #eee;
  padding: 0 20px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
}

.take_btn img {
  width: 24px;
  height: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/logindDrag.vue